export default __webpack_public_path__ + "img/d72db6378a5a846f015f9a835d25b38b.svg";